import { takeEvery, fork, all } from 'redux-saga/effects';
import {
    GET_ORDERS_LIST_DATA,
    GET_ALL_ORDERS_LIST_DATA,
    SET_ORDER_SUMMARY_MODAL_STATE,
    GET_DISTRICT,
    GET_TERRITORY,
    GET_ACCOUNTS,
    GET_REFINED_ORDERS_LIST_DATA,
    GET_SEARCH_RESULTS_ORDERS_LIST_DATA,
    DELETE_ORDER,
    VIEW_REPORT,
    SEND_USAGE_REPORT,
    SEND_INVOICE,
    GET_UNID_URL,
    FILTER_AND_ORDERLIST_UPDATE,
    VIEW_PDF_REPORT,
    SUBMIT_PROCEDURE_DATA,
    GET_DENIED_ORDER,
    GET_DENIED_ORDER_FILTER,
    GET_CHECK_ORDER_ACTION_ELIGIBILITY,
    RETRIGGER_EVENT_NOTIFICATION
} from '../actions';

import {
    getOrderListData,
    getAllOrderListData,
    getSearchOrdersList,
    refinedOrderListData,
    getFilterAndOrderListData,
    deniedOrderCount,
    deniedOrderFilter,
} from './ordersListSaga';
import orderSummarySaga from './orderSummarySaga';
import checkOrderActionEligibilitySaga from './checkOrderActionEligibilitySaga';
import getDistrictView from './orderDistrictSaga';
import getTerritory from './orderTerritorySaga';
import getAccount from './orderAccountSaga';
import deleteOrderSaga from './deleteOrderSaga';
import viewReportSaga from './viewReportSaga';
import sendReportSaga from './sendReportSaga';
import sendInvoiceSaga from './sendInvoiceSaga';
import retriggerEventNotification from './eventNotificationRetrigger';
import getUnidURLSaga from './unidURLSaga';
import reportPdfSaga from './reportPdfSaga';
import submitProcedureData from './submitReportProcedureData';
function* watchGetOrderListData() {
    yield takeEvery(GET_ORDERS_LIST_DATA, getOrderListData);
}
function* watchGetAllOrderListData() {
    yield takeEvery(GET_ALL_ORDERS_LIST_DATA, getAllOrderListData);
}
function* watchFilterAndOrderListData() {
    yield takeEvery(FILTER_AND_ORDERLIST_UPDATE, getFilterAndOrderListData);
}

function* watchGetSearchOrderListData() {
    yield takeEvery(GET_SEARCH_RESULTS_ORDERS_LIST_DATA, getSearchOrdersList);
}

function* watchOrderSummaryData() {
    yield takeEvery(SET_ORDER_SUMMARY_MODAL_STATE, orderSummarySaga);
}

function* watchCheckOrderActionEligibilityData() {
    yield takeEvery(GET_CHECK_ORDER_ACTION_ELIGIBILITY, checkOrderActionEligibilitySaga);
}

function* watchOrderDistrictData() {
    yield takeEvery(GET_DISTRICT, getDistrictView);
}

function* watchOrderTerritoryData() {
    yield takeEvery(GET_TERRITORY, getTerritory);
}

function* watchOrderAccountData() {
    yield takeEvery(GET_ACCOUNTS, getAccount);
}

function* watchRefinedOrderList() {
    yield takeEvery(GET_REFINED_ORDERS_LIST_DATA, refinedOrderListData);
}
function* watchGetDeniedOrder() {
    yield takeEvery(GET_DENIED_ORDER, deniedOrderCount);
}
function* watchGetDeniedOrderFilter() {
    yield takeEvery(GET_DENIED_ORDER_FILTER, deniedOrderFilter);
}

function* watchDeleteOrderSaga() {
    yield takeEvery(DELETE_ORDER, deleteOrderSaga);
}

function* watchViewReportSaga() {
    yield takeEvery(VIEW_REPORT, viewReportSaga);
}

function* watchViewPdfReportSaga() {
    yield takeEvery(VIEW_PDF_REPORT, reportPdfSaga);
}
function* watchSendReportSaga() {
    yield takeEvery(SEND_USAGE_REPORT, sendReportSaga);
}
function* watchRetriggerEventNotification() {
    yield takeEvery(RETRIGGER_EVENT_NOTIFICATION, retriggerEventNotification);
}

function* watchSendInvoiceSaga() {
    yield takeEvery(SEND_INVOICE, sendInvoiceSaga);
}

function* watchGetUnidURLSaga() {
    yield takeEvery(GET_UNID_URL, getUnidURLSaga);
}

function* watchSubmitProcedureData() {
    yield takeEvery(SUBMIT_PROCEDURE_DATA, submitProcedureData);
}

export default function* OrdersListSaga() {
    yield all([
        fork(watchGetOrderListData),
        fork(watchGetAllOrderListData),
        fork(watchFilterAndOrderListData), //newly added -> Two Calls
        fork(watchOrderSummaryData),
        fork(watchCheckOrderActionEligibilityData),
        fork(watchOrderDistrictData),
        fork(watchOrderTerritoryData),
        fork(watchOrderAccountData),
        fork(watchRefinedOrderList),
        fork(watchGetDeniedOrder),
        fork(watchGetDeniedOrderFilter),
        fork(watchGetSearchOrderListData),
        fork(watchDeleteOrderSaga),
        fork(watchViewReportSaga),
        fork(watchViewPdfReportSaga),
        fork(watchSendReportSaga),
        fork(watchSendInvoiceSaga),
        fork(watchGetUnidURLSaga),
        fork(watchSubmitProcedureData),
        fork(watchRetriggerEventNotification),
    ]);
}
